import React from 'react';
import {OrderHistoryDetailContent} from './sub-view/order-history-content';
import {UserLayout} from 'components/layouts/user';

class OrderHistoryDetailContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout active="user-order-history">
        <h1 className="user-header">Chi tiết đơn hàng</h1>
        <OrderHistoryDetailContent params={this.props.params}/>
      </UserLayout>
    );
  }
}

export default OrderHistoryDetailContainer;



// WEBPACK FOOTER //
// ./components/users/OrderHistoryDetailContainer.jsx